import nookies, { parseCookies } from 'nookies';
import querystring from 'querystring';
import urlJoin from 'url-join';
export const authCookieName = 'bl-owners-user';
export const sidCookieName = 'bl-sid';
export const getAuthServerCookie = (ctx) => nookies.get(ctx)[authCookieName];
export const getAuthClientCookie = () => parseCookies()[authCookieName];
export const getSidServerCookie = (ctx) => nookies.get(ctx)[sidCookieName];
export const getSidClientCookie = () => parseCookies()[sidCookieName];
export const parseAuthCookie = (encodedCookie) => {
    if (!encodedCookie || typeof encodedCookie !== 'string')
        return null;
    try {
        return JSON.parse(Buffer.from(decodeURIComponent(encodedCookie), 'base64').toString());
    }
    catch (_a) {
        return null;
    }
};
export const getServerParsedAuthCookie = (ctx) => parseAuthCookie(getAuthServerCookie(ctx));
export const getClientParsedAuthCookie = () => parseAuthCookie(getAuthClientCookie());
export const getRedirectUrl = (loginUrl, origin, pathname, query = {}) => {
    return `${loginUrl}?redirect=${urlJoin(origin, pathname, Object.keys(query).length > 0 ? `?${querystring.stringify(query)}` : '')}`;
};
